//region GraphQL query
import { gql } from '@apollo/client'

export const query = gql`
  query customerAddresses($filter: JSON, $options: JSON) {
    getCustomerAddresses(filter: $filter, options: $options) {
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
      type
      street3
      company
      name
      phone
    }
  }
`

export const customerFragment = gql`
  fragment customerFragment on Customer {
    _id
    profile {
      _id
      name
      picture
      email
    }
    status
    company {
      _id
      name
      domain
    }
    phone
    address {
      _id
      street1
      street2
      city
      state
      zip
      fullAddress
      country
    }
    addresses {
      _id
      street1
      street2
      city
      state
      zip
      fullAddress
      country
      status
    }
    ups {
      _id
      account
      postalCode
      countryCode
    }
  }
`
